import { Badge } from '@/components/ui/badge';
import { Loader2, Wifi, WifiOff } from 'lucide-react';

interface StatusBlockProps {
  connectedPhone: boolean;
  connectingPhone: boolean;
}

export function StatusBlock({ connectedPhone, connectingPhone }: StatusBlockProps) {
  if (connectingPhone) {
    return (
      <div className="flex items-center justify-center space-x-2 p-2">
        <Loader2 className="h-4 w-4 animate-spin text-blue-500" />
        <Badge variant="outline" className="text-blue-600 border-blue-200">
          Connecting...
        </Badge>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center space-x-2 p-2">
      {connectedPhone ? (
        <>
          <Wifi className="h-4 w-4 text-green-500" />
          <Badge variant="outline" className="text-green-600 border-green-200">
            Connected
          </Badge>
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4 text-red-500" />
          <Badge variant="outline" className="text-red-600 border-red-200">
            Disconnected
          </Badge>
        </>
      )}
    </div>
  );
}